import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="table" {...props} />;
}

export const meta = {
  id: 'CMSPageCustomFields',
  title: 'Page Custom Fields',
  category: 'CMS',
  // exposes: [],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Custom fields for the pages`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 630,
    height: 630
  }
};
